<div *ngIf="isLoading" class="w-100 text-center text-secondary">
  <div class="progress" style="height: .25rem; ">
    <div class="progress-bar progress-bar-striped progress-bar-animated w-100" role="progressbar"></div>
  </div>
</div>
